export default __webpack_public_path__ + "static/media/ttl-loader.0c03770b.gif";